import { useQuery } from '@tanstack/react-query'

import { listOaCreationJobs } from 'api'
import { queryKeys } from 'constants/queryKeys'
import { oaCreationStrings } from 'constants/strings'
import { useAuth } from 'contexts/AuthContext'
import type { TListOaCreationJobsResponse } from 'types'
import { toErrorMessage } from './utils'

type UseOaCreationJobsOptions = {
  currentPage?: number
  pageSize?: number
  /** ジョブが進行中の場合に画面側でポーリングするための間隔 (ms) */
  refetchIntervalMs?: number
}

type UseOaCreationJobsResult = {
  data: TListOaCreationJobsResponse | undefined
  loading: boolean
  error: string | undefined
  refetch: () => Promise<unknown>
}

export function useOaCreationJobs(
  options: UseOaCreationJobsOptions = {},
): UseOaCreationJobsResult {
  const { user } = useAuth()
  const { currentPage = 1, pageSize = 20, refetchIntervalMs } = options

  const query = useQuery({
    queryKey: [
      queryKeys.OA_CREATION_JOBS,
      user?.uid,
      currentPage,
      pageSize,
    ],
    enabled: Boolean(user?.uid),
    queryFn: () => listOaCreationJobs({ currentPage, pageSize }),
    retry: false,
    refetchInterval: refetchIntervalMs,
  })

  return {
    data: query.data,
    loading: Boolean(user?.uid) && query.isPending,
    error: query.error
      ? toErrorMessage(query.error, oaCreationStrings.errors.loadJobsFailed)
      : undefined,
    refetch: () => query.refetch(),
  }
}
